import * as React from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, RouteProps } from 'react-router';

import { IUserData } from '../../../infrastructure/interfaces';
import UserRoles from '../../../infrastructure/UsersRoles';

export interface IUserRouteProps extends RouteProps {
  user?: IUserData;
  path: string;
  component: any;
}

@(connect((state: any) => ({ user: state.user.data })) as any)
export default class UserRoute extends React.Component<IUserRouteProps>{

  render() {
    const {
      user,
      component: Component,
      ...rest
    } = this.props;
    return (
      <Route {...rest} render={(props) => {
        return (user && user.role === UserRoles.user)
            ? <Component />
            : <Redirect to="/Login" />;
      }} />);
  }
}




// WEBPACK FOOTER //
// ./src/components/App/components/UserRouter.tsx